<template>
  <thead>
    <tr>
      <td
        v-if="hasViewServiceProviderPermission"
        class="color-2 has-text-weight-medium has-text-centered"
        style="width: 12%"
      >
        Supplier
      </td>
      <td
        v-if="hasViewSalePricePermission && 0"
        class="color-2 has-text-weight-medium has-text-centered"
        style="width: 8%"
      >
        Price Unit
      </td>
      <td
        v-if="hasViewCostPricePermission"
        class="color-2 has-text-weight-medium has-text-centered"
        style="width: 6%"
      >
        Cost
        <b-tooltip
          v-if="service.prices_costs_margins.is_composite_service"
          size="is-small"
          multilined
          class="tooltipSales"
        >
          <template v-slot:content> Compound Service </template>
          <BIconStack class="infoIconSales color-4" />
        </b-tooltip>
      </td>
      <td v-if="hasViewSalePricePermission" class="color-2" style="width: 2%" />
      <td
        v-if="hasViewSalePricePermission"
        class="color-2 has-text-weight-medium has-text-centered"
        style="width: 12%"
      >
        Sales
        <b-tooltip size="is-small" multilined class="tooltipSales">
          <template v-slot:content>
            <b>p.r:</b> Price per range.<br /><b>p.p:</b>
            Price per person.
          </template>
          <IconInfo class="infoIconSales color-4" />
        </b-tooltip>
      </td>
      <td
        v-if="hasViewSalePricePermission"
        class="color-2 has-text-weight-medium has-text-centered"
        style="width: 12%"
      >
        Price Per Person
      </td>
      <td
        v-if="showQty"
        class="color-2 has-text-weight-medium has-text-centered"
        style="width: 8%"
      >
        Qty.
      </td>
    </tr>
  </thead>
</template>

<script>
import { mapGetters } from "vuex";
import { serviceHelper } from "@/utils/service";
import { PERMISSION, USER_ROLE } from "@/constants";
import helpers from "@/helpers";

export default {
  name: "ServiceResultHeader",
  props: {
    service: Object,
    showQty: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      authData: "auth/getAuthData",
    }),
    hasViewCostPricePermission() {
      return serviceHelper.hasAnyViewPermissions(
        this.authData,
        this.itinerary,
        [PERMISSION.VIEW_COST_PRICE, PERMISSION.VIEW_PRICE_SEARCHED]
      );
    },
    hasViewServiceProviderPermission() {
      return !helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.TRAVEL_AGENT],
        false
      );
    },
    hasViewSalePricePermission() {
      return serviceHelper.hasAnyViewPermissions(
        this.authData,
        this.itinerary,
        [PERMISSION.VIEW_SALE_PRICE, PERMISSION.VIEW_PRICE_SEARCHED]
      );
    },
  },
};
</script>

<style scoped></style>
